import React, { useCallback } from "react";
import { Input, TextField } from "@mui/material";
import { createUseStyles } from "$utils/createUseStyles";
import { Text, useFormContext } from "$components";
import { getFromLS, writetoLS } from "$utils/utils";
import { theme } from "$utils/theme/bataillog";

function InputNumber({
  label,
  className,
  onBlur,
  defaultValue = "",
  requiredText,
  regexText = "",
  name,
  placeholder = "",
  Child,
  outlineLabel = "",
  disabled,
  groupClass,
  errorRequired = false,
  errorRegex = false,
  value: DefValue,
  variant,
  additionalText = "",
}: any) {
  const classes = useStyles();
  const Type: any = outlineLabel === "" ? Input : TextField;
  const textOutline: object =
    outlineLabel === "" ? {} : { variant: "outlined", label: outlineLabel };

  const context = useFormContext();
  const inputText = context[name];

  const [value, setValue] = React.useState<string>(defaultValue || "");
  const [error, setError] = React.useState<string>("");

  const setStateValue = useCallback(
    (val: string) => {
      setValue(val);
      writetoLS(name, val);
    },
    [name]
  );

  const OnChange = (e: any) => {
    const val = e?.target?.value || "";
    const re = /^[0-9\b]+$/;
    if (val === "" || re.test(val)) {
      setStateValue(val);
    }
  };

  React.useEffect(() => {
    if (errorRequired) {
      setError(requiredText || "");
    } else if (errorRegex) {
      setError(regexText || "");
    } else if (DefValue) {
      setStateValue(DefValue);
    } else if (inputText?.value) {
      setStateValue(inputText.value);
    }
  }, [
    inputText,
    errorRegex,
    errorRequired,
    DefValue,
    requiredText,
    regexText,
    setStateValue,
  ]);

  React.useEffect(() => {
    const val = getFromLS(name);
    if (val && inputText?.value !== "") {
      setStateValue(val);
    }
  }, [inputText?.value, name, setStateValue]);

  return (
    <div className={`${classes.inputGroup} ${groupClass ?? ""}`}>
      {label && (
        <label className={classes.inputLabel} htmlFor={name}>
          <Text>{label}</Text>
          <Text className={classes.additionalText}>{additionalText}</Text>
        </label>
      )}
      <Type
        type={variant || undefined}
        name={name}
        onChange={OnChange}
        onBlur={onBlur}
        value={value}
        autoComplete="off"
        spellCheck="false"
        autoCapitalize="none"
        id={name}
        disabled={disabled || inputText?.disabled || false}
        placeholder={placeholder}
        className={`${classes.textInput} ${className ?? ""}`}
        {...textOutline}
      />
      <Text className={classes.errorField}>{error !== "" && error}</Text>
      {inputText?.Child || Child || null}
    </div>
  );
}
export default React.memo(InputNumber);

const useStyles = createUseStyles(() => ({
  inputGroup: {
    display: "flex",
    flexDirection: "column",
    marginBottom: "14px",
    flex: 1,
    marginRight: "10px",
    "&.ProjectCode": {
      flex: "unset",
      width: "288px",
    },
  },
  inputLabel: {
    marginBottom: "16px",
  },
  textInput: {
    flex: 1,
    border: `1px solid ${theme.color.gray2}`,
    paddingLeft: 10,
    paddingRight: 10,
    "&:before": {
      display: "none",
    },
    "& input": {
      height: 29,
      fontSize: 15,
    },
    "&.Mui-disabled": {
      backgroundColor: theme.color.gray2,
      color: "#000 !important",
    },
  },
  errorField: {
    minHeight: 20,
    color: theme.color.red,
    fontSize: 12,
  },
  additionalText: {
    fontStyle: "italic",
  },
}));
